// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <MAvatar
      src={user.user_profile}
      alt={user.user_display_name}
      // color={user.user_profile ? 'default' : createAvatar(user.user_display_name).color}
      {...other}
    >
      {createAvatar(user.user_display_name).name}
    </MAvatar>
  );
}
